import Icon from "../Icon";
import React from "react";

export default props => {

    return (
        <div className="afs-msm-stage-close-button" onClick={props.onCloseClicked}>
            <Icon icon="close7" iconSize="25" iconFill="white"/>
        </div>
    );
};